import { orderStatusLabels } from "constant"

const getOrderStatusTitle = (order) => {
  if (order.isPaymentProblematic) return "عدم_تایید_پرداخت"

  if (order.isDispatched) return "خروج_از_انبار"

  const isOrderAddedByAccess =
    order.accountId !== order.addedByAccountId

  const inComplete =
    !order.isCod &&
    order.accountRole === "user" &&
    order.orderStatus === "pending" &&
    !isOrderAddedByAccess

  if (inComplete) return "ناقص"

  return orderStatusLabels[order.orderStatus]
}

export default getOrderStatusTitle